module.exports = __webpack_public_path__ + "img/3-(11).93eff9e1.jpg";